// extracted by mini-css-extract-plugin
export default {"root":"checkbox_root__Gr86p","input":"checkbox_input__yl-vo","mark":"checkbox_mark__b0RE2","error":"checkbox_error__+0eu-"};